import React from "react";
import { Link } from "react-router-dom";
// import ScrollLink from "./ScrollLink";

function Menu({ removeMenu }) {
  return (
    <nav className="nav-menu">
      <ul className="list-menu">
        <li>
          <Link to="/" className="active" onClick={removeMenu}>
            home
          </Link>
        </li>
        <li>
          <Link to="/aboutus" onClick={removeMenu}>
            about us
          </Link>
        </li>
        <li>
          <Link
            to="https://medium.com/@solobachi02/tech-skills-have-been-evolving-and-have-come-to-stay-in-this-our-era-2d179216c6ca"
            target="_blank"
            onClick={removeMenu}
          >
            blog
          </Link>
        </li>
        <li>
          <Link to="/services" onClick={removeMenu}>
            services
          </Link>
        </li>
        <li>
          <Link className="cta-btn" to="/signup" onClick={removeMenu}>
            sign up
          </Link>
        </li>
        <li>
          <Link to="/login" className="cta-btn" onClick={removeMenu}>
            sign in
          </Link>
        </li>
      </ul>
    </nav>
  );
}

export default Menu;
